import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { RobotsExclusion } from '@portal-core/sites/models/robots-exclusion.model';

@CollectionStateSelectors({
  stateType: RobotsExclusionState
})
@State<RobotsExclusionState>({
  name: RobotsExclusionState.source,
})
@Service({ autoProvided: false })
export class RobotsExclusionState extends CollectionStateBase {
  static override source = 'RobotsExclusion';
  getSource(): string {
    return RobotsExclusionState.source;
  }
}

@Service()
export class RobotsExclusionDataService extends CollectionDataServiceBase<RobotsExclusion> {
  protected readonly stateType = RobotsExclusionState;
}
